import {
  BUILDING_SINGLE_FIELD_API,
  CONTRACT_SINGLE_FIELD_API,
  INHABITANT_SINGLE_FIELD_API,
  REQUEST_CATEGORY_SINGLE_FIELD_API,
  REQUEST_SINGLE_FIELD_API,
} from '../../constants/api'
import {
  BUILDING_ENTITY,
  BUILDING_GROUP_ENTITY,
  CHAT_ENTITY,
  CONTRACT_ENTITY,
  DOC_FLOW_ENTITY,
  DOCUMENTS_ENTITY,
  EMAIL_ENTITY,
  FLAT_ENTITY,
  INHABITANT_ENTITY,
  LABEL_ENTITY,
  NEWSBOARD_ENTITY,
  PROVIDER_ENTITY,
  REQUEST_ENTITY,
  SINGLE_EMAIL_ENTITY,
  STAFF_MEMBER_REQUEST_CATEGORIES_ENTITY,
  TASK_ENTITY,
} from '../../constants/entity'
import {
  ATTACH_FIELD_NAME,
  DOC_FLOW_RESULT_STATUS_FILTER_LIST,
  FILE_FIELD_NAME,
  UPLOADING_FIELD_NAME,
} from '../../constants/filter'
import { FileListItem, ListItem } from '../ListItem'
import { StatusListItem } from '../StatusListItem'

import {
  getContractorFilterListItem,
  getDocFlowResultStatusFilterListItemPropsGetters,
  getFilterListItemsByNames,
  getRequestFilterListItem,
} from './Filter.utils'

export const FILTER_NAME_ARCHIVED = 'archived'

export const FILTER_NAME_UNREAD = 'unread'

export const EXCLUDE_FILTERS = [FILTER_NAME_ARCHIVED, FILTER_NAME_UNREAD]

export const FILTER_SINGLE_FIELD_API_ALIASES = {
  [BUILDING_ENTITY.single]: BUILDING_SINGLE_FIELD_API,
  [BUILDING_GROUP_ENTITY.single]:
    'idwell-api/api/v3/construction/building-groups/single-field/',
  [CHAT_ENTITY.single]: 'idwell-api/api/v3/chat/chats/single-field/',
  [CONTRACT_ENTITY.single]: CONTRACT_SINGLE_FIELD_API,
  [DOC_FLOW_ENTITY.single]:
    'api/document-stapling/document-staplings/single-field/',
  [DOCUMENTS_ENTITY.single]: 'api/v4/file/single-field/',
  [EMAIL_ENTITY.single]: 'idwell-api/api/v3/email/email-threads/single-field/',
  [FLAT_ENTITY.single]: 'idwell-api/api/v3/construction/flats/single-field/',
  [INHABITANT_ENTITY.single]: INHABITANT_SINGLE_FIELD_API,
  [LABEL_ENTITY.single]: 'idwell-api/api/v3/customization/labels/single-field/',
  [NEWSBOARD_ENTITY.single]: '/idwell-api/api/v3/news/posts/single-field/',
  [PROVIDER_ENTITY.single]:
    '/idwell-api/api/v3/contractor/contractors/single-field/',
  [REQUEST_ENTITY.single]: REQUEST_SINGLE_FIELD_API,
  [SINGLE_EMAIL_ENTITY.single]:
    'idwell-api/api/v3/email/no-thread-view-email-messages/single-field/',
  [STAFF_MEMBER_REQUEST_CATEGORIES_ENTITY.single]:
    REQUEST_CATEGORY_SINGLE_FIELD_API,
  [TASK_ENTITY.single]: 'idwell-api/api/v3/pipeline/activities/single-field/',
}

const LINKED_REQUEST_FIELD_NAME = 'linked_request'
const REQUEST_FIELD_NAME = 'request'

export const FILTER_LIST_ITEM = {
  ...getFilterListItemsByNames({
    ListItem: StatusListItem,
    names: DOC_FLOW_RESULT_STATUS_FILTER_LIST,
  }),
  [ATTACH_FIELD_NAME]: FileListItem,
  [FILE_FIELD_NAME]: FileListItem,
  [LINKED_REQUEST_FIELD_NAME]: ListItem,
  [REQUEST_FIELD_NAME]: ListItem,
  [UPLOADING_FIELD_NAME]: FileListItem,
}

export const FILTER_LIST_ITEM_PROPS_GETTER = {
  ...getDocFlowResultStatusFilterListItemPropsGetters(),
  [LINKED_REQUEST_FIELD_NAME]: getRequestFilterListItem,
  [PROVIDER_ENTITY.single]: getContractorFilterListItem,
  [REQUEST_FIELD_NAME]: getRequestFilterListItem,
}

export const FILTER_REQUEST_PARAM_NAME_VALUES = 'items'

export const FILTER_REQUEST_PARAM_NAME_PERMANENT_FILTERS = 'permanentFilters'

export const FILTER_TEMPLATE_NAME_FIELD = 'name'

export const FILTER_TEMPLATE_NAME_FIELD_PUBLIC = 'is_public'

export const FILTER_TEMPLATE_NAME_MAX_LENGTH = 255
